import Main from './Main'
import Lista from './components/Financeira'
import Novo from './components/NovaFinanceira'

export default [
  {
    path: 'pc-financeira',
    name: 'policiacivil.processo.financeira',
    component: Main,
    redirect: { name: 'policiacivil.processo.financeira.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.processo.financeira.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.processo.financeira.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.processo.financeira.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/processo/financeira/routes.js